import { render, staticRenderFns } from "./AltAccounts.vue?vue&type=template&id=07e568ea&scoped=true"
import script from "./AltAccounts.vue?vue&type=script&lang=js"
export * from "./AltAccounts.vue?vue&type=script&lang=js"
import style0 from "./AltAccounts.vue?vue&type=style&index=0&id=07e568ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e568ea",
  null
  
)

export default component.exports